import { Button, Intent, Spinner } from "@blueprintjs/core"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { ToastError } from "../../../components"
import { DetailCard } from "../components/CommonStyled.styled"
import { useGetTradingDatasetQuery } from "../hooks/useGetTradingDatasetQuery"
import DatasetForm from "./DatasetForm"

const DatasetDetail = () => {
  const { datasetId } = useParams()
  const navigate = useNavigate()
  const { data: dataset, isLoading, error } = useGetTradingDatasetQuery(datasetId ?? "")

  // Redirect to datasets page when there's an error
  useEffect(() => {
    if (error) {
      // Short delay to allow the toast to be displayed before redirecting
      const redirectTimer = setTimeout(() => {
        navigate("/config/datasets")
      }, 1500)

      return () => clearTimeout(redirectTimer)
    }
  }, [error, navigate])

  if (isLoading) {
    return (
      <DetailCard>
        <Spinner intent={Intent.PRIMARY} />
      </DetailCard>
    )
  }

  return (
    <DetailCard>
      <FlexContainer justifyContent="flex-start">
        <Button
          icon="arrow-left"
          text="Back to datasets"
          onClick={() => navigate("/config/datasets")}
        />
      </FlexContainer>
      {!error && <DatasetForm selectedDataset={dataset} />}
      {error && dataset && (
        <ToastError
          error={error}
          errorMessage={"Unable to load dataset, please try to refresh the page."}
        />
      )}
    </DetailCard>
  )
}

export default DatasetDetail
